module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callback-container"
  }, [_c('div', {
    staticClass: "top-tips"
  }, [_c('p', [_vm._v("\n            （1）根据实际的使用需要，设置相应的回调地址，只支持https（例：https://xx.zonelink.com 或 https://xx.zonelink.com/xx），不支持http、IP地址、端口号及短链域名。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （2）填写的域名须通过ICP备案的验证。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （3）若不使用回调删除对应的回调地址即可。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （4）需要打印结果回调时调用打印接口时需附加设置好的回调地址参数backurl，详见 "), _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.gotoDoc
    }
  }, [_vm._v("开发文档")]), _vm._v(" 。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （5）"), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("【重要】回调地址必须提供一个")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("GET")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("方法，返回")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("ZONELINK-SUCCESS")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("用于云服务器检测接口是否可用")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "callback-form"
  }, [_c('el-form', {
    ref: "callbackForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回调地址：",
      "prop": "backUrl",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入打印结果回调地址（只支持https）"
    },
    model: {
      value: (_vm.form.backUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "backUrl", $$v)
      },
      expression: "form.backUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.saveCallbackUrl
    }
  }, [_vm._v("保存地址")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reloadCallbackUrl
    }
  }, [_vm._v("重新加载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.deleteCallbackUrl
    }
  }, [_vm._v("删除地址")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40dcd8e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/callback.vue
// module id = 332
// module chunks = 1